import { render, staticRenderFns } from "./legal_female.vue?vue&type=template&id=686c705c&scoped=true&"
var script = {}
import style0 from "./legal_female.vue?vue&type=style&index=0&id=686c705c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c705c",
  null
  
)

export default component.exports